import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SprintService } from '../sprint.service';
import { TaskService } from '../task.service';
import { ListMySprintsRequest, Sprint, Task } from '../protogen/planning/service_pb';
import { isTaskClosed } from '../tasks';

@Component({
  selector: 'app-sprint-details',
  templateUrl: './sprint-details.component.html',
  styleUrls: ['./sprint-details.component.scss']
})
export class SprintDetailsComponent implements OnInit {
  dataLoaded: boolean = false;
  sprint: Sprint.AsObject = new Sprint().toObject();
  tasks: Task.AsObject[] = [];

  prevSprint?: Sprint.AsObject;
  nextSprint?: Sprint.AsObject;

  private taskPromises: Promise<Task.AsObject>[] = [];

  constructor(private activatedRoute: ActivatedRoute,
              private sprintService: SprintService,
              private taskService: TaskService) {
    this.fetchSprintDetails();
  }

  ngOnInit(): void {
    // This is necessary because Angular tries to reuse components when routing.
    this.activatedRoute.params.subscribe(newParams => {
      this.fetchSprintDetails();
    });
  }

  async fetchSprintDetails() {
    this.prevSprint = undefined;
    this.nextSprint = undefined;

    const sprintId = this.activatedRoute.snapshot.paramMap.get('sprintId');
    if (sprintId) {
      const listSprintsResponsePromise = this.sprintService.listMySprints(new ListMySprintsRequest());
      const sprintDetailsResponse = await this.sprintService.getSprintDetails(sprintId);

      if (sprintDetailsResponse.sprint) {
        this.sprint = sprintDetailsResponse?.sprint;
        this.dataLoaded = true;

        // Sprints are ordered in descending order of sprint id.
        const allSprints = (await listSprintsResponsePromise).sprintsList;
        if (allSprints.length > 0) {
          const thisIndex = allSprints.findIndex(s => s.id === sprintId);
          if (thisIndex > 0) {
            this.nextSprint = allSprints[thisIndex - 1];
          }
          if (thisIndex < allSprints.length - 1) {
            this.prevSprint = allSprints[thisIndex + 1];
          }
        }

        // Fetch all tasks so we can late-render them.
        this.tasks = [];
        this.taskPromises = [];
        for (const taskId of this.sprint.tasksList) {
          this.taskPromises.push(this.taskService.getTask(taskId));
        }
        this.tasks = (await Promise.all(this.taskPromises)).sort((a, b) => {
          // Closed tasks sort before open tasks.
          if (isTaskClosed(a) !== isTaskClosed(b)) {
            return isTaskClosed(a) ? -1 : 1;
          }
          // Then sort by descending task id.
          return parseInt(b.id || '0') - parseInt(a.id || '0');
        });
      }
    }
  }
}
